import Swiper from 'swiper'
import {Navigation} from "swiper/modules";

export default function () {
    document.addEventListener('DOMContentLoaded', () => {
        function init(element: HTMLElement) {
            const sliderEl = element;

            if (!sliderEl) return
            new Swiper(sliderEl, {
                slidesPerView: 1,
                speed: 500,
                loop: true,
                modules: [Navigation],
                navigation: {
                    prevEl: '[data-section-banners-slider] .slider-control-left',
                    nextEl: '[data-section-banners-slider] .slider-control-right'
                },

            })
        }


        const elements = document.querySelectorAll('[data-section-banners-slider]')

        elements.forEach((element) => {
            if (element instanceof HTMLElement) {
                init(element)
            }
        })
    })
}
